// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from "@/store/index";
import Vuelidate from 'vuelidate'
import Zhe2Dialog from '@/plugins/dialog/install'
import {
  getENV,
  hashHasAppid,
  getParamsFromUrl,
  makeUrl,
  setTitle,
  hashHasChannel,
  hashHasToken,
  getVersion,
  isAndroidBrower,
  isIphoneBrower,
  isAlipay,
  isWeixin,
  inZhe2,
  envIsDev,
  envIsTest,
  getClientInfo,
  getClientToken, isAndroid, isDevelopment, envIsPro, getVersionFromUA,
} from "./lib/util"

import auth2 from "./lib/auth2";
import Install from './lib/install'
import weuijs from 'weui.js'
import {systemService} from "./services/system";
import {aidCAche, appidConfigCache, clearCache, getStartHash} from "./lib/cache";
import Vant, {Dialog} from 'vant'
import VueCompositionAPI from '@vue/composition-api'
import 'vant/lib/index.css'
import {CURRENT_VERESION, VERSION5_2_4} from "@/lib/version";
import {MAIN_COLOR} from "@/lib/config";
import {inWhiteList, wechatService} from "@/services/wechat";
import requestLoading from "@/lib/requestLoading";
import diyBack from "@/lib/diyBack";
import {cancelPayToPage} from "@/lib/cancelPayToPage";
import {_log, _sum} from "@/lib/monitor";
import {loadScript} from "@/utils/loadScript";
import {i18n} from "@/i18n/i18n";
// import {decryptByECB, encryptByECB} from "@/lib/cryptojs";
// import {getDPI} from "@/utils/getDPI";
// console.log(encodeURIComponent(encryptByECB('http://192.168.228.1:10015//外送报告/2023/04/20/33A002_20230321G0307502.pdf')));

/**
 * 错误捕获
 */
Vue.config.errorHandler = function (err, vm, info) {
  console.log('【vue errorHandler】');
  _log('error', info + " : " + err.toString());
  console.error(err);
}

window.onerror = function (msg, url, lineNo, columnNo, error) {
  _log('error', `${url} at ${lineNo}:${columnNo} is ${msg.toString()}`);
  console.log('【window.onerror】');
  console.log(msg);
  console.log(url);
  console.log(lineNo);
  console.log(columnNo);
  console.error(error);
}

window.onunhandledrejection = function (event) {
  console.log('【window.onunhandledrejection】');
  _log('error', event.reason);
  console.error(event);
}

// abc();

const startHash = getStartHash.get(location.hash);
Log('startHash', startHash);
window.bus = new Vue();
window.startHash = startHash.value;
// console.log('getDPI', getDPI());

requestLoading(window.bus); // 全局 loading
diyBack(window.bus); // 自定义返回到指定页
cancelPayToPage(window.bus); // 取消支付后跳转到指定页面


let currentUrl = location.href;
let p = getParamsFromUrl(currentUrl);
const hash = url('#') || {};


// 个别路径强制使用http打开
const forceHttp = ['/daysurgery/news/detail'];
const inForceHttp = () => {
  return p.protocol === 'https' && forceHttp.some(r => location.hash && location.hash.includes(r));
}

// 个别域名强制重定向到wx.hztywl.cn
const inForceHost = () => p.hostname === 'test-zheer-wx.hztywl.cn' || p.hostname === 'nethosweb.diandianys.com'

if (inForceHost() && isWeixin()) {
  p.hostname = 'wx.hztywl.cn';
  p.protocol = 'http'
  location.replace(makeUrl(p));
} else if (p.query && p.query.openid && isWeixin()) {
  delete p.query.openid;
  location.replace(makeUrl(p));
} else if (!p.query || !p.query.v || p.query.v !== CURRENT_VERESION) {
  p.query = Object.assign({}, p.query, {
    v: CURRENT_VERESION
  });
  location.replace(makeUrl(p));
} else if (p.hash && hashHasAppid(hash) && !(p.query.appid)) {
  p.query = Object.assign({}, p.query, {
    appid: hashHasAppid(hash)
  });
  location.replace(makeUrl(p));
} else if (p.hash && hashHasChannel(hash) && !(p.query.channel)) {
  p.query = Object.assign({}, p.query, {
    channel: hashHasChannel(hash)
  });
  location.replace(makeUrl(p));
} else if (p.hash && hashHasToken(hash) && !(p.query.token)) {
  p.query = Object.assign({}, p.query, {
    token: hashHasToken(hash)
  });
  location.replace(makeUrl(p));
} else if (!p.query.channel) {
  p.query = Object.assign({}, p.query, {
    channel: getENV().channel
  });
  location.replace(makeUrl(p));
} else if (p.query.channel && p.query.channel === '1001') {
  p.query = Object.assign({}, p.query, {
    channel: 2
  });
  location.replace(makeUrl(p));
} /*else if (inForceHttp()) {
  p.protocol = 'http';
  p.query.notice = 'forceHttp'
  location.replace(makeUrl(p));
}*/
/* else if (p.query.token) {
  init();
}*/ else {
  getVersion().then(data => {
    if (data.updateStatus && data.updateStatus == 1) {
      Dialog.alert({
        message: '系统升级中，请稍后再试',
        confirmButtonColor: MAIN_COLOR,
      })
    } else if (data.version === CURRENT_VERESION) {
      auth2(erudaInit);
    } else {
      Dialog.confirm({
        message: '有新版本，是否升级？',
        confirmButtonColor: MAIN_COLOR,
        confirmButtonText: '立即升级'
      })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          auth2(erudaInit);
        })
    }
  })
}

window.androidCallBack = () => {
  alert('android调用');
  if (bus) {
    bus.$emit('androidCallBack', true);
  }
}

function erudaInit() {
  // 非生产环境，加载vconsole
  if (!envIsPro()) {
    loadScript('./static/js/eruda/eruda.js').then(() => {
      eruda.init();
      init();
    })
  } else {
    init();
  }
}


function init() {
  const version = getVersionFromUA();
  _log('info', `${encodeURIComponent(window.navigator.userAgent)}：${version}`);
  // 清理废弃缓存
  clearCache()
  Log('CURRENT_VERESION', CURRENT_VERESION)
  Log('AID', aidCAche.get());

  // 获取channel init;
  const appid = p.query.appid || getENV().appid;
  const channel = p.query.channel || '';
  if (channel) {
    systemService.channelDetails(channel).then((obj) => {
      initVue(obj).then(() => {
      });
    }).catch(() => {
    })
  } else if (appid) {
    systemService.appidDetails(appid).then(({obj, msg}) => {
      initVue(obj).then(() => {
      });
    }).catch(() => {
    })
  }
}

async function initVue(obj) {
  appidConfigCache.set(obj);
  // 网页title
  setTitle(obj.channelName);
  if (isAlipay()) {
    setTitle('浙江大学医学院附属第二医院');
  }

  // 微信全局隐藏分享、复制链接等
  if (isWeixin()) {
    if (!inWhiteList(p.hash))
      wechatService.hideAllNonBaseMenuItem(obj.appid).then(() => {
      });
    else {
      wechatService.getWxConfig(obj.appid).then(() => {
      });
    }
  }

  // zhe2 app 打开
  if (inZhe2()) {
    if (isAndroidBrower()) {
      await createApp(obj);
    } else if (isIphoneBrower()) {
      await createApp(obj);
    }
  }
  // 微信打开
  else if (isWeixin() && (await checkChannelHasAppidDialog(obj))) {
    await createApp(obj)
  }
  // 支付宝打开
  else if (isAlipay()) {
    await createApp(obj);
  } else {
    await createApp(obj);
  }
}


async function createApp(obj) {
  window.vm = null;
  if ((isIphoneBrower() || isAndroidBrower()) && !isDevelopment() && (envIsDev() || envIsTest())) {
    await noticeDialog();
  }
  Vue.use(VueCompositionAPI)
  Vue.use(Install);
  Vue.use(Vuelidate);
  // 增加Vant
  Vue.use(Vant)
  Vue.config.productionTip = false
  Vue.config.ignoredElements = ['wx-open-launch-weapp'];
  //自定义弹窗组件
  Vue.use(Zhe2Dialog);
  routeHook(obj.appid);
  window.vm = new Vue({
    data() {
      return {
        appidConfig: obj,
        appid: obj.appid,
        startHash: ''
      }
    },
    el: '#app', i18n, router, store, template: '<App/>', components: {App}, appidConfig: obj
  });

  if (!getENV().plat || !getENV().oauthurl) {
    Dialog.confirm({
      title: '温馨提示',
      message: '您的程序版本较旧，是否刷新重试?',
      confirmButtonText: '继续使用',
      confirmButtonColor: MAIN_COLOR,
      cancelButtonText: '刷新重试'
    }).then(() => {
    }).catch(e => {
      location.reload();
    })
  }
}


function noticeDialog() {
  return Dialog.alert({
    title: '温馨提示',
    messageAlign: 'left',
    message: `开发、测试环境基本信息获取\nHOST：${location.host}\nUA：${window.navigator.userAgent.toLowerCase()}\n客户端：${getClientInfo(window.navigator.userAgent.toLowerCase())}\nHistoryLength：${history.length}\nStartHash：${location.hash}\n是否设置token：来源${getClientToken().from}，值为${getClientToken().token}\ntoken是否暴露：${p.query.token ? '是' : "否"}`,
    confirmButtonText: '我知道了',
    confirmButtonColor: MAIN_COLOR
  }).then(() => true);
}

function routeHook(appid) {
  /* eslint-disable no-new */
  router.beforeEach(async (to, from, next) => {
    store.commit('setRouterLoading', true);
    // new history().set(to.fullPath);
    _sum('页面.' + `${to.path}`);
    // Log('historypp.position, historypp.list', historypp.position, historypp.list);
    Log('to,from', to.fullPath, from.fullPath, history.length);
    if (to.path === '/bindRelativePhone' || to.path === '/scanBind') {
      if ((!isWeixin() && !isAlipay()) && !isDevelopment()) {
        weuijs.confirm("继续使用该功能需要下载app", {
          title: '提示', isAndroid: false, buttons: [{
            label: '取消', type: 'default', onClick: function () {
              window.history.go(-1);
            }
          }, {
            label: '确认', type: 'primary', onClick: function () {
              location.replace('m.html#/download');
            }
          }]
        });
        /*if (confirm('继续使用该功能需要下载app')) {
          location.replace('m.html#/download');
        }*/
        next(new Error('redirect'));
      } else next();
    } else next();
  });

  router.afterEach(async (to, from) => {
    store.commit('setRouterLoading', false);
    Log('afterEach to from', to.fullPath, from.fullPath);
    if (isWeixin() && isAndroid()) {
      await wechatService.getWxConfig(appid);
      if (!inWhiteList(to.fullPath))
        await wechatService.hideAllNonBaseMenuItem();
    }
  })
}

/**
 * confirm
 * @desc 各种检测的dialog.confirm
 */

/**
 * channel 的 config 是否包含appid
 */
function checkChannelHasAppidDialog(config) {
  if (config.appid) return true
  return Dialog.confirm({
    message: 'channel配置中无appid，将会影响您的分享、支付等功能，是否继续使用？',
    confirmButtonColor: MAIN_COLOR,
    confirmButtonText: '继续使用'
  }).then(() => true).catch(() => false)
}

// console.log((decryptByECB(decodeURIComponent('R86Wft3KvarqSHPhdRsSWq0QfhE1rx%2FOLWzbg9gW6RKzU4iCe5qVJQ%3D%3D'))))



// WEBPACK FOOTER //
// ./src/main.js